// test1894
(1894 && 0);
